import React from 'react'
import AreYouSurePopup from '../common/popup/AreYouSurePopup'
import {DocumentBaseRequest, BooleanApiData} from '../../api/data-contracts'
import {Api_Document_DeleteDocument} from '../../apiClient/apiClient'
import {postRequestAsync} from '../../redux/commonSlice'
import {getDocumentState, loadDocuments} from '../../redux/documentSlice'
import {useDispatch, useSelector} from 'react-redux'

function DocumentDeleteButton(props: {documentId: string}) {
  const dispatch = useDispatch()

  async function deleteDocument(documentId: string) {
    const body: DocumentBaseRequest = {
      documentId: documentId,
    }
    await dispatch<any>(
      postRequestAsync({
        postRequestFunction: Api_Document_DeleteDocument,
        body: body,
      })
    )
      .unwrap()
      .then((response: BooleanApiData) => {
        dispatch<any>(loadDocuments())
      })
  }

  return (
    <AreYouSurePopup
      message='Dosyayı Silmek İstediğinizden Emin misiniz?'
      modalOpener={
        <a type='button' className='btn btn-sm btn-icon btn-light btn-danger'>
          <i className='fa-solid fa-trash'></i>
        </a>
      }
      onClick={() => {
        deleteDocument(props.documentId ?? '')
      }}
    />
  )
}

export default DocumentDeleteButton
